import "./index.scss";
import { MODAL_STATUS } from "./constants";
import Hook from "./useStatusModal";
import { CheckIcon } from "@moneris-portal/svg-components";
import errorIcon from "../../assets/error_icon.svg";

const StatusModal = (props) => {
  const { type } = props;
  const { BLOCK, translate, visible, handleClose } = Hook.useStatusModal(props);

  const isSuccess =
    type === MODAL_STATUS.success ||
    type === MODAL_STATUS.disconnected ||
    type === MODAL_STATUS["change-plan-success"] ||
    type === MODAL_STATUS["cancel-subscription-success"] ||
    type === MODAL_STATUS["reactivate-success"];
  const isError =
    type === MODAL_STATUS.error || type === MODAL_STATUS["disconnect-error"];

  if (!visible) return null;

  return (
    <div className={`${BLOCK.current} ${BLOCK.current}--${type}`} role="alert">
      {isSuccess && <CheckIcon />}
      {isError && (
        <img
          src={errorIcon}
          alt=""
          aria-hidden="true"
          className={`${BLOCK.current}__error-icon`}
        />
      )}
      <span className={`${BLOCK.current}__message`}>
        {translate(`message-${MODAL_STATUS[type]}`)}
      </span>
      <button
        type="button"
        className={`${BLOCK.current}__close-btn`}
        onClick={handleClose}
        aria-label="Close"
      >
        ✕
      </button>
    </div>
  );
};

export default StatusModal;

